/* ==========================================================================
   WAENN — Carrusel "Comunidad WAENN"
   ==========================================================================
   Fila de fotos con scroll horizontal simple (sin efecto coverflow, a
   diferencia del carrusel de looks: aqui las fotos van pegadas unas a
   otras, formato scuffers.com). Al hacer click en una foto se abre un
   panel con la foto grande (el @usuario superpuesto abajo, como una
   publicacion de Instagram) y, al lado, las prendas de ese look para
   comprar -- igual mecanica de "Añadir todo a la cesta" que el carrusel
   de looks (sections/waenn-looks-carousel.liquid /
   assets/waenn-looks-carousel.js), pero con sus propios ids/clases
   ("waenn-community-*") para no interferir si ambos carruseles conviven
   en la misma pagina.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Guardar look (icono esquina superior derecha, referencia bershka.com
     "BY INFLUENCERS"): usa el MISMO motor de Guardados que el resto del
     sitio (window.WaennWishlist, definido en assets/waenn-wishlist.js,
     que se carga antes que este archivo desde layout/theme.liquid), asi
     el look guardado aparece tambien en el drawer de Guardados junto a
     los productos guardados -- en vez de vivir en un localStorage propio
     que nadie mas puede leer.

     Cada look se guarda con id "look-<block.id>" (prefijo para no
     colisionar nunca con un id de producto real, que en Shopify siempre
     es numerico puro) y lleva type: 'look' para que
     assets/waenn-wishlist.js sepa pintarlo como tarjeta de look (foto +
     @usuario + prendas etiquetadas) en vez de como fila de producto.
     ------------------------------------------------------------------ */

  function buildLookItem(id, look) {
    return {
      type: 'look',
      productId: 'look-' + id,
      lookId: id,
      handle: (look && look.handle) || '',
      image: (look && look.image) || '',
      products: ((look && look.products) || []).map(function (product) {
        return {
          title: product.title || '',
          url: product.url || '',
          image: product.image || '',
          price: product.price || '',
        };
      }),
    };
  }

  function syncSaveButtons(root) {
    if (!window.WaennWishlist) return;
    var buttons = root.querySelectorAll('[data-waenn-community-save]');
    buttons.forEach(function (btn) {
      var id = btn.getAttribute('data-community-id');
      if (!id) return;
      var saved = window.WaennWishlist.isSaved('look-' + id);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Quitar de guardados' : 'Guardar look');
    });
  }

  function initSaveButtons(root, looks) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-waenn-community-save]'));
    if (buttons.length === 0 || !window.WaennWishlist) return;

    syncSaveButtons(root);
    window.addEventListener(window.WaennWishlist.CHANGE_EVENT, function () {
      syncSaveButtons(root);
    });

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var id = btn.getAttribute('data-community-id');
        if (!id) return;
        var index = parseInt(btn.getAttribute('data-community-index'), 10);
        var look = looks && !isNaN(index) ? looks[index] : null;
        window.WaennWishlist.toggle(buildLookItem(id, look));

        btn.classList.remove('is-bouncing');
        void btn.offsetWidth;
        btn.classList.add('is-bouncing');
        window.setTimeout(function () {
          btn.classList.remove('is-bouncing');
        }, 420);
      });
    });
  }

  function initInstance(root) {
    var dataScript = root.querySelector('[data-waenn-community-data]');
    var panel = root.querySelector('[data-waenn-community-panel]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-waenn-community-open]'));
    if (!dataScript || !panel || slides.length === 0) return;

    var looks = [];
    try {
      looks = JSON.parse(dataScript.textContent) || [];
    } catch (e) {
      looks = [];
    }

    initSaveButtons(root, looks);

    // Mismo motivo que en el carrusel de looks: si esta seccion vive
    // dentro de un contenedor con transform (p.ej. el scroll por paginas
    // de la portada), position:fixed dejaria de fijarse a la ventana
    // real. Sacar el panel al final de <body> lo evita.
    document.body.appendChild(panel);

    var panelImage = panel.querySelector('[data-waenn-community-panel-image]');
    var panelHandle = panel.querySelector('[data-waenn-community-panel-handle]');
    var panelProducts = panel.querySelector('[data-waenn-community-panel-products]');
    var panelError = panel.querySelector('[data-waenn-community-panel-error]');
    var addAllBtn = panel.querySelector('[data-waenn-community-add-all]');
    var addAllText = panel.querySelector('[data-waenn-community-add-all-text]');
    var prevBtn = panel.querySelector('[data-waenn-community-prev]');
    var nextBtn = panel.querySelector('[data-waenn-community-next]');
    var closeEls = panel.querySelectorAll('[data-waenn-community-close]');
    var openIndex = null;
    var lastFocusedEl = null;

    function renderProduct(product) {
      var row = document.createElement('div');
      row.className = 'waenn-community-panel__product';

      var img = document.createElement('img');
      img.src = product.image || '';
      img.alt = product.title || '';
      row.appendChild(img);

      var info = document.createElement('div');
      info.className = 'waenn-community-panel__product-info';

      var title = document.createElement('p');
      title.className = 'waenn-community-panel__product-title';
      var link = document.createElement('a');
      link.href = product.url || '#';
      link.textContent = product.title || '';
      title.appendChild(link);
      info.appendChild(title);

      var price = document.createElement('p');
      price.className = 'waenn-community-panel__product-price';
      price.textContent = product.price || '';
      info.appendChild(price);

      var variants = (product.variants || []).filter(function (v) {
        return v.available;
      });
      var allVariants = product.variants || [];
      var usableVariants = variants.length > 0 ? variants : allVariants;

      if (usableVariants.length > 1) {
        var select = document.createElement('select');
        select.className = 'waenn-community-panel__product-size';
        select.setAttribute('data-variant-select', '');
        usableVariants.forEach(function (variant) {
          var option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title;
          select.appendChild(option);
        });
        info.appendChild(select);
      } else if (usableVariants.length === 1) {
        row.setAttribute('data-single-variant-id', usableVariants[0].id);
      }

      if (variants.length === 0) {
        var soldOut = document.createElement('p');
        soldOut.className = 'waenn-community-panel__product-price';
        soldOut.textContent = 'Agotado';
        info.appendChild(soldOut);
      }

      row.setAttribute('data-product-row', '');
      row.appendChild(info);
      return row;
    }

    function openPanel(index) {
      var look = looks[index];
      if (!look) return;
      openIndex = index;

      panelImage.src = look.image || '';
      panelImage.alt = look.handle || '';
      if (look.handle) {
        panelHandle.textContent = look.handle;
        panelHandle.hidden = false;
      } else {
        panelHandle.hidden = true;
      }
      panelProducts.innerHTML = '';
      panelError.hidden = true;

      (look.products || []).forEach(function (product) {
        panelProducts.appendChild(renderProduct(product));
      });

      prevBtn.disabled = looks.length <= 1;
      nextBtn.disabled = looks.length <= 1;

      lastFocusedEl = document.activeElement;
      panel.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      panel.querySelector('.waenn-community-panel__close').focus();
    }

    function closePanel() {
      panel.hidden = true;
      openIndex = null;
      document.documentElement.style.overflow = '';
      if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
        lastFocusedEl.focus();
      }
    }

    function navigate(step) {
      if (openIndex === null || looks.length === 0) return;
      var next = (openIndex + step + looks.length) % looks.length;
      openPanel(next);
    }

    slides.forEach(function (item) {
      var index = parseInt(item.getAttribute('data-community-index'), 10);
      item.addEventListener('click', function () {
        openPanel(index);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', function (event) {
      if (panel.hidden) return;
      if (event.key === 'Escape') closePanel();
      if (event.key === 'ArrowRight') navigate(1);
      if (event.key === 'ArrowLeft') navigate(-1);
    });

    prevBtn.addEventListener('click', function () {
      navigate(-1);
    });
    nextBtn.addEventListener('click', function () {
      navigate(1);
    });

    addAllBtn.addEventListener('click', function () {
      var rows = Array.prototype.slice.call(panelProducts.querySelectorAll('[data-product-row]'));
      var items = [];
      var missing = false;

      rows.forEach(function (row) {
        var select = row.querySelector('[data-variant-select]');
        var variantId = select ? select.value : row.getAttribute('data-single-variant-id');
        if (!variantId) {
          missing = true;
          return;
        }
        items.push({ id: variantId, quantity: 1 });
      });

      if (missing || items.length === 0) {
        panelError.hidden = false;
        return;
      }

      panelError.hidden = true;
      addAllBtn.disabled = true;
      var originalText = addAllText.textContent;
      addAllText.textContent = 'Añadiendo...';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cartDrawerEl = document.querySelector('cart-drawer');
      var sectionsToRequest =
        cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function'
          ? cartDrawerEl.getSectionsToRender().map(function (section) {
              return section.id;
            })
          : ['cart-drawer', 'cart-icon-bubble'];

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: sectionsToRequest,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart-add-failed');
          return res.json();
        })
        .then(function (data) {
          addAllBtn.disabled = false;
          addAllText.textContent = originalText;
          if (cartDrawerEl && data && data.sections && typeof cartDrawerEl.renderContents === 'function') {
            cartDrawerEl.renderContents(data);
          }
          closePanel();
        })
        .catch(function () {
          addAllBtn.disabled = false;
          addAllText.textContent = originalText;
          panelError.textContent = 'No se ha podido añadir el look al carrito. Inténtalo de nuevo.';
          panelError.hidden = false;
        });
    });
  }

  function init() {
    var instances = document.querySelectorAll('.waenn-community');
    Array.prototype.forEach.call(instances, initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
